import { Button } from '../../shared/ui/Button';

export function ContractEndedScreen({ onSignOut, actionLabel = 'Sair' }: { onSignOut: () => void; actionLabel?: string }) {
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', background: 'var(--color-background)' }}>
      <div style={{ display: 'grid', gap: '1rem', textAlign: 'center', maxWidth: '28rem', padding: '2rem' }}>
        <h1 style={{ fontSize: '1.25rem', margin: 0 }}>Contrato encerrado</h1>
        <p style={{ margin: 0, color: 'var(--color-text-secondary)' }}>
          O contrato desta clínica com o Ardix foi encerrado e o acesso ao sistema foi desligado. Os dados estão
          preservados e serão entregues ao responsável pelo contrato.
        </p>
        <p style={{ margin: 0 }}>
          Contato: <a href="mailto:suporte@ardix.com.br">suporte@ardix.com.br</a>
        </p>
        <div>
          <Button variant="ghost" onClick={onSignOut}>{actionLabel}</Button>
        </div>
      </div>
    </div>
  );
}
